import { graphql } from "gql";

const INTERNAL_ADMIN_USER_ATTRIBUTE_QUERY = graphql(`
  query InternalAdminUserAttribute($id: [ID!]!) {
    internalAdminUserAttribute(id: $id) {
      ...InternalAdminUserAttribute
    }
  }
`);

export default INTERNAL_ADMIN_USER_ATTRIBUTE_QUERY;
